(function () {
  if (customElements.get('aa-announcement')) return;

  class AaAnnouncement extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-aa-announce-slide]'));
      this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;
      this.timer = 0;
      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onPause = () => this.stop();
      this.onFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.play();
      };

      this.querySelector('[data-aa-announce-prev]')?.addEventListener('click', this.onPrev);
      this.querySelector('[data-aa-announce-next]')?.addEventListener('click', this.onNext);
      this.addEventListener('mouseenter', this.onPause);
      this.addEventListener('mouseleave', this.play);
      this.addEventListener('focusin', this.onPause);
      this.addEventListener('focusout', this.onFocusOut);
      this.play();
    }

    disconnectedCallback() {
      this.stop();
      this.querySelector('[data-aa-announce-prev]')?.removeEventListener('click', this.onPrev);
      this.querySelector('[data-aa-announce-next]')?.removeEventListener('click', this.onNext);
      this.removeEventListener('mouseenter', this.onPause);
      this.removeEventListener('mouseleave', this.play);
      this.removeEventListener('focusin', this.onPause);
      this.removeEventListener('focusout', this.onFocusOut);
    }

    move(step) {
      if (this.slides.length < 2) return;
      const next = (this.index + step + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === next;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.toggleAttribute('inert', !active);
      });
      this.index = next;
      this.play();
    }

    play() {
      this.stop();
      if (this.slides.length < 2) return;
      if (this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const interval = Number(this.dataset.interval) || 5000;
      this.timer = window.setInterval(() => this.move(1), interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = 0;
    }
  }

  customElements.define('aa-announcement', AaAnnouncement);
})();
